import { render, staticRenderFns } from "./previous-video-audit.vue?vue&type=template&id=143eaf30&"
import script from "./previous-video-audit.vue?vue&type=script&lang=js&"
export * from "./previous-video-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports